module.exports = __webpack_public_path__ + "static/Adel-kerouani-895fe92b1b9ed01dbca06a8761b5234d.jpg";